export const DEFAULT_WS_CONNECTION_RETRY_VALUE = 5;